import { render, staticRenderFns } from "./personalUpgrade__list.vue?vue&type=template&id=a4aa0fb0"
import script from "./personalUpgrade__list.vue?vue&type=script&lang=js"
export * from "./personalUpgrade__list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports